import * as React from "react";
import { MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function InTheNeighborhood() {
  const stats = [];
  return <section data-section-id="223473" id="global-reach" className="relative w-full py-20 md:py-24 bg-white overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <div className="space-y-10 lg:pr-12">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold tracking-tighter text-foreground font-serif">
                Connecting Communities <br />
                <span className="italic font-medium text-foreground/70">Across Every Border.</span>
              </h2>
              
              <p className="text-lg text-secondary leading-relaxed max-w-xl font-sans font-light">
                GLYPHIC fosters meaningful communication through a dedicated network of professional interpreters. 
                We are committed to bridging language gaps with empathy and precision, ensuring every voice is heard 
                in critical medical and legal moments.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4">
              {stats.map((stat, i) => <div key={i} data-index={i} className="space-y-1">
                  <div className="flex items-center gap-2 text-foreground">
                    <stat.icon className="w-4 h-4" />
                  </div>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="rounded-sm px-8 h-12 shadow-md bg-foreground text-background hover:bg-foreground/90">
                <Link to="/ServicesPage">Our Services</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-sm px-8 h-12 border-foreground text-foreground hover:bg-foreground/5">
                <Link to="/ConnectPage">Contact Us</Link>
              </Button>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 bg-foreground/5 rounded-sm blur-3xl -z-10" />
            
            <Card className="rounded-sm shadow-sm border-border/40 bg-card-warm/50 backdrop-blur-sm overflow-hidden">
              <div className="relative aspect-video overflow-hidden bg-muted/30">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649121/img/professional_workspace_minimalist.png" alt="High-end minimalist professional workspace" className="w-full h-full object-cover" loading="lazy" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649121/img/professional_workspace_minimalist.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649121/img/professional_workspace_minimalist.png-wvc-sizes" />
              </div>
              
              <CardHeader className="space-y-1">
                <CardTitle className="text-xl font-bold tracking-tight flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-foreground" />
                  Global Presence
                </CardTitle>
                <CardDescription className="text-xs uppercase tracking-wider">
                  Supporting diverse regions worldwide
                </CardDescription>
              </CardHeader>
              
              <CardContent className="pb-8">
                <p className="text-sm text-secondary">
                  Our presence spans multiple continents, providing localized expertise with a global perspective 
                  to ensure cultural nuance is never lost in translation.
                </p>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}